import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { FileItem, FileLikeObject } from 'ng2-file-upload';
import { getFileTypeFromName, SupportedFileExtensions } from '@app/interfaces/file.interface';
import { FileWrapper } from '@app/modules/dialogs/upload-dialog/upload-dialog.component';

export type FileAction = 'delete' | 'locked';

export type FilePlaceholder = 'empty' | `sample.${SupportedFileExtensions}`;

@Component({
    selector: 'app-file-item',
    templateUrl: './file-item.component.html',
    styleUrls: ['./file-item.component.scss'],
    imports: [CommonModule, MatProgressBarModule, MatIconModule],
})
export class FileItemComponent implements OnInit {
    public static EMPTY_IMAGE: FilePlaceholder = 'empty';

    @Input() file: FileWrapper | FilePlaceholder;
    @Output() performAction: EventEmitter<FileWrapper> = new EventEmitter();

    public fileWrapper: FileWrapper;
    public isRejected: boolean = false;
    public isSample: boolean = false;

    public type: string = '';
    public progress: number;

    ngOnInit() {
        if (typeof this.file === 'string') {
            if (this.file === FileItemComponent.EMPTY_IMAGE) {
                this.type = FileItemComponent.EMPTY_IMAGE;
            }

            if (this.file.startsWith('sample')) {
                this.fileWrapper = {
                    file: { file: { name: 'Vzorový dokument' } as FileLikeObject } as FileItem,
                } as FileWrapper;
                this.setTypeFromName(this.file);
            }
        } else {
            this.fileWrapper = this.file;
            this.isRejected = this.fileWrapper.documentFile?.status === 'rejected';
            this.setTypeFromName(this.fileWrapper.file?.file?.name);

            this.fileWrapper.file.onProgress = (progress: number) => {
                this.progress = progress;
            };
        }
    }

    private setTypeFromName(fileName: string) {
        this.type = getFileTypeFromName(fileName);
    }

    public performActionClick(): void {
        this.performAction.emit(this.fileWrapper);
    }
}
